<!-- Navbar -->
<nav class="layout-navbar container-xxl navbar navbar-expand-xl navbar-detached align-items-center bg-navbar-theme"
  id="layout-navbar">
  <div class="layout-menu-toggle navbar-nav align-items-xl-center me-3 me-xl-0 d-xl-none">
    <a class="nav-item nav-link px-0 me-xl-4" href="javascript:void(0)">
      <i class="ti ti-menu-2 ti-sm"></i>
    </a>
  </div>
  <div class="navbar-nav-right d-flex align-items-center" id="navbar-collapse">
    <app-building-dropdown></app-building-dropdown>

    <ul class="navbar-nav flex-row align-items-center ms-auto">
      <li class="nav-item me-2 me-xl-0" (click)="logout()">
        <a class="nav-link" href="javascript:void(0);">
          <i class="ti ti-lock fs-4"  ngbTooltip="logout" placement="bottom"></i>
        </a>
      </li>
      <!-- Style Switcher -->
      <li class="nav-item me-2 me-xl-0" (click)="toogleTheme()">
        <a class="nav-link style-switcher-toggle hide-arrow" href="javascript:void(0);">
          <i class="ti ti-md fs-4" [ngbTooltip]="isDark?'Light mode':'Dark mode'" placement="bottom" [ngClass]="isDark?'ti-sun':'ti-moon-stars'"></i>
        </a>
      </li>
      <!--/ Style Switcher -->

      <!-- Notification -->
      <app-notification-ring></app-notification-ring>
      <!--/ Notification -->

      <!-- User -->
      <li ngbDropdown class="">
        <a ngbDropdownToggle class="nav-link dropdown-toggle hide-arrow" href="javascript:void(0);" >
          <div class="flex-shrink-0">
            <div class="avatar">
              <ng-container *ngIf="avatar && !avatarLoadFailed; else initials">
                <img [src]="avatar" class="rounded-circle header-avatar-image" alt="avatar" (error)="onAvatarError()" />
              </ng-container>
              <ng-template #initials>
                <span class="avatar-initial rounded-circle bg-label-primary">
                  {{ getUserInitials() }}
                </span>
              </ng-template>
            </div>
          </div>
        </a>
        <ul ngbDropdownMenu  class="dropdown-menu dropdown-menu-end position-fixed">
          <li>
            <a class="dropdown-item" href="javascript:void(0)">
              <div class="d-flex">
                <div class="flex-shrink-0 me-3">
                  <div class="avatar">
                    <ng-container *ngIf="avatar && !avatarLoadFailed; else initialsLarge">
                      <img [src]="avatar" class="rounded-circle header-avatar-image" alt="avatar" (error)="onAvatarError()" />
                    </ng-container>
                    <ng-template #initialsLarge>
                      <span class="avatar-initial rounded-circle bg-label-primary">
                        {{ getUserInitials() }}
                      </span>
                    </ng-template>
                  </div>
                </div>
                <div class="flex-grow-1">
                  <span class="fw-semibold d-block">{{loggedInUserinfo ? (loggedInUserinfo.first_name + ' ' + loggedInUserinfo?.last_name) : ''}}</span>
                  <small class="text-muted">{{loggedInUserinfo?.role_name}}</small>
                </div>
              </div>
            </a>
          </li>
          <li>
            <div class="dropdown-divider"></div>
          </li>
          <li >
            <a ngbDropdownItem class="dropdown-item" [routerLink]="['/app/account']" [queryParams]="{ tab: 'Profile' }">
              <i class="ti ti-user-check me-2 ti-sm"></i>
              <span class="align-middle">My Profile</span>
            </a>
          </li>
          <li >
            <a ngbDropdownItem class="dropdown-item" [routerLink]="['/app/account']" [queryParams]="{ tab: 'Security' }">
              <i class="ti ti-settings me-2 ti-sm"></i>
              <span class="align-middle">Settings</span>
            </a>
          </li>
          <li >
            <a ngbDropdownItem class="dropdown-item" href="javascript:void(0)">
              <span class="d-flex align-items-center align-middle">
                <i class="flex-shrink-0 ti ti-credit-card me-2 ti-sm"></i>
                <span class="flex-grow-1 align-middle">Billing</span>
                <!-- <span class="flex-shrink-0 badge badge-center rounded-pill bg-label-danger w-px-20 h-px-20">2</span> -->
              </span>
            </a>
          </li>
          <li >
            <div class="dropdown-divider"></div>
          </li>
          <li >
            <a ngbDropdownItem class="dropdown-item" href="javascript:void(0)" (click)="logout()" target="_self">
              <i class="ti ti-logout me-2 ti-sm"></i>
              <span class="align-middle">Log Out</span>
            </a>
          </li>
        </ul>
      </li>
      <!--/ User -->
    </ul>
  </div>

  <!-- Search Small Screens -->
  <div class="navbar-search-wrapper search-input-wrapper d-none">
    <input type="text" class="form-control search-input container-xxl border-0" placeholder="Search..."
      aria-label="Search..." />
    <i class="ti ti-x ti-sm search-toggler cursor-pointer"></i>
  </div>

  <ng-container #alarmPopupHost></ng-container>
</nav>
<!-- / Navbar -->
